export function changeDeleteCustomReportCustomer()
{
    return({
        type:"CHANGE_DELETE_CUSTOM_REPORT_CUSTOMER",
    })
}